import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from '../../constant'
import axios from 'axios'

/**
 * FETCH DETAILS    
 * Create an async thunk to fetch the addresses
 */
 
export const fetchAddresses = createAsyncThunk('banner/fetchAddresses', async (user_id, { rejectWithValue, getState }) => {
    const { token } = getState().user; // Get the token from the Redux store

    try {
        const res = await axios.get(API_BASE_URL + '/fetch-addresses', {
            params: { user_id },
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`, // Include the token here
            }
        });

        // console.log("Address Actions data:", res.data.data);
        return res.data.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});


/**
 * SELECTED ADDRESS    
 * 
 */
export const setUserSelectedAddress = createAsyncThunk( 'address/setUserSelectedAddress', async (address, { rejectWithValue }) => {
      try {
        // Simulate an API call or async operation (e.g., sending the selected address to a server)
        // For now, we can return the address directly
        return address;
      } catch (error) {
        // Handle and return the error
        return rejectWithValue(error.message || 'Failed to set address');
      }
    }
);

/**
 * STORE ADDRESS
 * 
 */

export const storeAddress = createAsyncThunk('address/storeAddress', async (data, { rejectWithValue, getState }) => {
    const { token } = getState().user;

    console.log("Data:", data);

    try {
        const res = await axios.post(`${API_BASE_URL}/store-address`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`, // Include the token here
            },
        });
        console.log("Response Data:", res.data);
        return res.data;
    } catch (error) {
        console.log(error.response?.data || error.message)
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * REMOVE ADDRESS
 */
export const removeAddress = createAsyncThunk('address/removeAddress', async ({ user_id, address_id }, { rejectWithValue, getState }) => {
    const { token } = getState().user;

    try {
        const res = await axios.delete(`${API_BASE_URL}/remove-address`, {
            data: { user_id, address_id }, // Pass data in the request body for DELETE
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        return { success: true, address_id }; // Return address_id for optimistic UI updates
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * EDIT ADDRESS
 */
export const updateAddress = createAsyncThunk('address/updateAddress', async (data, { rejectWithValue, getState }) => {
    const { token } = getState().user;

    try {
        const res = await axios.put(`${API_BASE_URL}/update-address`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});


/**
 * FETCH Countries    
 * Create an async thunk to fetch the addresses
 */
 
export const fetchCountry = createAsyncThunk('banner/fetchCountry', async (user_id, { rejectWithValue, getState }) => {
    const { token } = getState().user; // Get the token from the Redux store

    try {
        const res = await axios.get(API_BASE_URL + '/countries', {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`, // Include the token here
            }
        });

        // console.log("Address Actions data:", res.data.data);
        return res.data.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

/**
 * FETCH States    
 * Create an async thunk to fetch the addresses
 */
 
export const fetchStates = createAsyncThunk('banner/fetchStates', async (user_id, { rejectWithValue, getState }) => {
    const { token } = getState().user; // Get the token from the Redux store

    try {
        const res = await axios.get(API_BASE_URL + '/states', {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`, // Include the token here
            }
        });

        // console.log("Address Actions data:", res.data.data);
        return res.data.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});